import script from "./DepartmentToggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepartmentToggle.vue?vue&type=script&lang=ts&setup=true"

import "./DepartmentToggle.vue?vue&type=style&index=0&id=597a7db6&lang=css"

const __exports__ = script;

export default __exports__